function makeLinkRelative(link = "/") {
  const regexp = /https?:\/\/[^\/]*/;
  const relativeLink = link.replace(regexp, "");

  return relativeLink;
}

function hostOf(url) {
  const match = String(url).match(/^(?:https?:)?\/\/([^/?#]+)/i);

  return match ? match[1].toLowerCase() : "";
}

/**
 * Normalise a URL authored in a WordPress link field.
 *
 * Those fields are typed by hand, so they arrive in three shapes: absolute
 * against the WordPress host (which would link visitors to the backend),
 * internal paths missing the trailing slash Gatsby builds pages with, and
 * genuinely external URLs. Only the first two are rewritten.
 */
function normalizeWpLinkUrl(url, wpUrl) {
  if (!url || typeof url !== "string") return url;

  const trimmed = url.trim();

  // mailto:, tel:, in-page anchors and the like are left alone
  if (/^(?!https?:)[a-z][a-z0-9+.-]*:/i.test(trimmed) || trimmed.startsWith("#")) {
    return trimmed;
  }

  let path = trimmed;

  // Compare hosts rather than whole prefixes, so a link saved with the other
  // scheme (http:// vs https://) or protocol-relative still counts as internal.
  const absolute = trimmed.match(/^(?:https?:)?\/\/[^/?#]+(.*)$/i);

  if (absolute) {
    const wpHost = hostOf(wpUrl);

    // absolute URL on some other host - external, keep verbatim
    if (!wpHost || hostOf(trimmed) !== wpHost) return trimmed;

    path = absolute[1] || "/";
  }

  if (!path.startsWith("/")) path = `/${path}`;

  // keep query string and hash out of the trailing-slash handling
  const suffixIndex = path.search(/[?#]/);
  const suffix = suffixIndex === -1 ? "" : path.slice(suffixIndex);
  let pathname = suffixIndex === -1 ? path : path.slice(0, suffixIndex);

  const lastSegment = pathname.split("/").filter(Boolean).pop() || "";
  const pointsAtFile = lastSegment.includes(".");

  if (!pointsAtFile && !pathname.endsWith("/")) {
    pathname = `${pathname}/`;
  }

  return `${pathname}${suffix}`;
}

module.exports = {
  makeLinkRelative,
  normalizeWpLinkUrl,
};
